import { ScheduleGridBodyCellProps } from 'components/ScheduleGrid/ScheduleGrid.Types';
import ServiceStore from 'stores/ServiceStore';
import { utils } from '@intrasync/utils';

type OrderStatus =
    | 'ordered'
    | 'shipped'
    | 'received'
    | 'installed'
    | 'pending';

interface HardwareItem {
    orderNumber: string;
    orderDate: string;
    jobNumber: number;
    status?: OrderStatus;
    quantity: number;
    type: string;
}

interface HardwareScheduleRightBodyCellProps extends ScheduleGridBodyCellProps {
    itemsFromEntity: HardwareItem[];
    commentsStore: ServiceStore;
}

const HardwareScheduleRightBodyCell = (props: HardwareScheduleRightBodyCellProps) => {
    if (props.itemsFromEntity?.length === 0) {
        return (
            <div
                style={{
                    border: '1px solid #000',
                    ...props.style,
                    backgroundColor: '#f0f0f0',
                }}
            />
        );
    }

    const { itemsFromEntity } = props;

    const itemsByOrderNumber = utils.groupBy(
        itemsFromEntity as unknown as Record<string | number, string>[],
        'orderNumber'
    );

    const currentOrderNumbers = Object.keys(itemsByOrderNumber);
    const currentMainEntity = itemsFromEntity[0];

    // Determine status color based on order status
    const allStatuses: OrderStatus[] = [
        'ordered',
        'shipped',
        'received',
        'installed',
        'pending'
    ];

    const orderStatus: OrderStatus =
        currentMainEntity.status ||
        allStatuses[Math.floor(parseFloat(currentMainEntity.orderNumber || '0') % allStatuses.length)];

    const statusColor = {
        ordered: 'blue',
        shipped: 'orange',
        received: 'purple',
        installed: 'green',
        pending: 'gray'
    }[orderStatus];

    // Calculate total quantity across all orders
    const totalQuantity = itemsFromEntity.reduce((acc, item) => {
        return acc + (item.quantity || 0);
    }, 0);

    // Count different hardware types
    const uniqueTypes = new Set(itemsFromEntity.map(item => item.type)).size;

    return (
        <div
            style={{
                border: '1px solid #000',
                ...props.style,
                overflow: 'hidden',
                backgroundColor: '#f0f0f0',
            }}
        >
            <div
                style={{
                    backgroundColor: '#fff',
                    borderRadius: '5px',
                    border: `2px solid ${statusColor}`,
                    padding: '5px',
                    margin: '5px',
                    textAlign: 'center',
                    height: '78%',
                }}
            >
                <div>
                    <b>{currentOrderNumbers.length}</b> {currentOrderNumbers.length === 1 ? 'Order' : 'Orders'}
                </div>
                <div>
                    <b>{uniqueTypes}</b> {uniqueTypes === 1 ? 'Type' : 'Types'}
                </div>
                <div>
                    <b>{totalQuantity}</b> Items
                </div>
                <div style={{
                    color: statusColor,
                    fontWeight: 'bold',
                    marginTop: '5px'
                }}>
                    {orderStatus.charAt(0).toUpperCase() + orderStatus.slice(1)}
                </div>
            </div>
        </div>
    );
};

export default HardwareScheduleRightBodyCell;